import { FC, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { demoBasePath, hasDemoPathPrefix, isDemoSession } from '@/shared/lib';

// The router basename is fixed at creation, so changing it requires a full reload.
export const DemoRouteSync: FC = () => {
  const routerRelativeLocation = useLocation();

  const isDemoUrl = hasDemoPathPrefix(window.location.pathname);
  const isMismatch = isDemoSession() !== isDemoUrl;

  useEffect(() => {
    if (isMismatch) {
      window.location.replace(
        `${demoBasePath()}${routerRelativeLocation.pathname}${routerRelativeLocation.search}${routerRelativeLocation.hash}`,
      );
    }
  }, [isMismatch, routerRelativeLocation]);

  if (isMismatch) {
    return null;
  }

  return <Outlet />;
};
